// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__lqUPL","spin":"Loader_spin__RjWvZ","tiny":"Loader_tiny__7NSuL","small":"Loader_small__ke0+L","medium":"Loader_medium__iiqBt","large":"Loader_large__AmCVk"};